import { Viewport } from 'pixi-viewport'

const DEFAULT_WORLD_WIDTH = 2000
const DEFAULT_WORLD_HEIGHT = 2000

let viewport

export function create(renderer) {
    viewport = new Viewport({
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        worldWidth: DEFAULT_WORLD_WIDTH,
        worldHeight: DEFAULT_WORLD_HEIGHT,
        passiveWheel: false,
        interaction: renderer.plugins.interaction,
    })

    viewport
        .drag()
        .decelerate()
        .pinch({ noDrag: true })
        .wheel()

    applyConstraints()

    viewport.fit()
    viewport.moveCenter(DEFAULT_WORLD_WIDTH / 2, DEFAULT_WORLD_HEIGHT / 2)
}

function applyConstraints() {
    // Remove existing plugins before re-applying
    viewport.plugins.remove('bounce')
    viewport.plugins.remove('clamp')
    viewport.plugins.remove('clamp-zoom')

    viewport.bounce({
        sides: 'all',
        underflow: 'center',
    })

    viewport.clamp({
        direction: 'all',
        underflow: 'center',
    })

    viewport.clampZoom({
        minScale: window.innerWidth < 800 ? 0.35 : 0.65,
        maxScale:  window.innerWidth < 800 ? 2 : 2.5,
    })
}

export function updateWorld(width, height) {
    viewport.worldWidth = width
    viewport.worldHeight = height
    applyConstraints()
    viewport.fit()
    viewport.moveCenter(width / 2, height / 2)
}

export function get() {
    return viewport
}
